import {Component} from '@angular/core';

@Component({
  selector: 'date-node',
  templateUrl: './date-node.component.html'
})
export class DateNodeComponent {
    node
}
